"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CadstromObjectTypeSchema = exports.CadstromObjectType = void 0;
const zod_1 = require("zod");
var CadstromObjectType;
(function (CadstromObjectType) {
    CadstromObjectType["BomItem"] = "bomitm";
    CadstromObjectType["Build"] = "b";
    CadstromObjectType["Boundary"] = "bnd";
    CadstromObjectType["DifferentialPair"] = "diffpair";
    CadstromObjectType["DocumentChunk"] = "dchunk";
    CadstromObjectType["FileIndexEntry"] = "fi";
    CadstromObjectType["InferenceHistory"] = "infhist";
    CadstromObjectType["InferredDataEntry"] = "infentry";
    CadstromObjectType["Manufacturer"] = "mfgr";
    CadstromObjectType["ManufacturerAlias"] = "mfgralias";
    CadstromObjectType["Membership"] = "mbr";
    CadstromObjectType["Operation"] = "op";
    CadstromObjectType["Organization"] = "org";
    CadstromObjectType["PackageFunction"] = "func";
    CadstromObjectType["PackageGroundTruthReview"] = "pkggtrev";
    CadstromObjectType["PackageMode"] = "mode";
    CadstromObjectType["PackageStorePackage"] = "pkg";
    CadstromObjectType["PackageStorePackageFamily"] = "pkgfam";
    CadstromObjectType["PackageStorePin"] = "pkgpin";
    CadstromObjectType["PackageTag"] = "pkgtag";
    CadstromObjectType["Project"] = "p";
    CadstromObjectType["ProjectComponent"] = "prjcmp";
    CadstromObjectType["ProjectModel"] = "prjmodel";
    CadstromObjectType["ProjectModule"] = "prjmodule";
    CadstromObjectType["ResolutionEntry"] = "resentry";
    CadstromObjectType["Requirement"] = "req";
    CadstromObjectType["Session"] = "sess";
    CadstromObjectType["AgentChatConversation"] = "agconv";
    CadstromObjectType["Signal"] = "sig";
    CadstromObjectType["Tag"] = "tag";
    CadstromObjectType["User"] = "u";
    CadstromObjectType["Evidence"] = "evidence";
    CadstromObjectType["Claim"] = "claim";
    CadstromObjectType["Finding"] = "finding";
    CadstromObjectType["DenormalizedPackageStorePackageSnapshot"] = "psnap";
    CadstromObjectType["PackageBenchmarkDataset"] = "pbd";
    CadstromObjectType["PackageBenchmarkDatasetSample"] = "pbds";
    CadstromObjectType["Experiment"] = "exp";
    CadstromObjectType["ExperimentSampleResult"] = "expsr";
    CadstromObjectType["ExperimentScoring"] = "expscore";
    CadstromObjectType["ResolutionScoringRun"] = "resrun";
    CadstromObjectType["PackageEvaluation"] = "pkgeval";
    CadstromObjectType["PackageGroundTruthAssertion"] = "pgta";
    CadstromObjectType["PackageDataErrorStatement"] = "pdes";
    CadstromObjectType["PackageDataAdjudicationItem"] = "pdai";
    CadstromObjectType["PackageDataAdjudicationRequest"] = "pdar";
    CadstromObjectType["FileEvidenceLocator"] = "fevl";
    CadstromObjectType["EvidenceVote"] = "evvt";
    CadstromObjectType["ConsensusRun"] = "consrun";
    CadstromObjectType["WizardPlan"] = "wizplan";
    CadstromObjectType["WizardStep"] = "wizstep";
    CadstromObjectType["WizardInput"] = "wizinput";
    CadstromObjectType["WizardOutput"] = "wizoutput";
    CadstromObjectType["WizardFragment"] = "wizfrag";
    CadstromObjectType["WizardFragmentLink"] = "wizlink";
    CadstromObjectType["WizardReview"] = "wizrev";
    CadstromObjectType["WizardReviewReplicaSet"] = "wizrevset";
    CadstromObjectType["UserCapability"] = "usrcap";
    CadstromObjectType["NetworkView"] = "netview";
    CadstromObjectType["CircuitState"] = "cs";
    CadstromObjectType["AssertionDefinition"] = "asrt";
    CadstromObjectType["AssertionConfiguration"] = "asrtcfg";
    CadstromObjectType["RequirementAssertionResult"] = "asrtres";
    CadstromObjectType["RequirementLogEntry"] = "asrtlog";
    CadstromObjectType["RequirementAttachment"] = "asrtatch";
    CadstromObjectType["BuildDesignObject"] = "bdo";
    CadstromObjectType["CustomSubject"] = "csubj";
    CadstromObjectType["PackageDataSpecClause"] = "pdsc";
    CadstromObjectType["PackageInferenceErrorCode"] = "piec";
    CadstromObjectType["SignalMappingRun"] = "smrun";
})(CadstromObjectType || (exports.CadstromObjectType = CadstromObjectType = {}));
exports.CadstromObjectTypeSchema = zod_1.default.nativeEnum(CadstromObjectType);
//# sourceMappingURL=CadstromObjectType.js.map